<template>
  <div>
    <v-data-table :headers="taskHeaders" :items="filteredItems" style="border: solid 1px;">
      <template v-slot:top>
        <v-row dense class="px-3">
          <v-col cols="12">
            <v-text-field
              label="Search by task"
              variant="underlined"
              v-model="taskSearch"
              clearable
              hide-details
              prepend-inner-icon="mdi-magnify"
              maxlength="200"
            >
            </v-text-field>
          </v-col>
          <v-col cols="6">
            <v-autocomplete
              :items="owners"
              variant="underlined"
              item-title="displayName"
              item-value="id"
              return-object
              label="Owner"
              hide-no-data
              v-model="owner"
              hide-selected
              clearable
              autocomplete="new-password"
            ></v-autocomplete>
          </v-col>
          <v-col cols="6">
            <v-autocomplete
              :items="taskListTypes"
              variant="underlined"
              item-title="value"
              item-value="key"
              return-object
              label="Required in order to"
              hide-no-data
              v-model="taskListType"
              hide-selected
              clearable
              autocomplete="new-password"
            ></v-autocomplete>
          </v-col>
        </v-row>
      </template>
      <template v-slot:item="props">
        <tr>
          <td>
            <a @click="editTask(props.item)" class="blue-link">{{ props.item.name }}</a>
          </td>
          <td>{{ props.item.taskListType.value }}</td>
          <td>{{ props.item.owner ? props.item.owner.displayName : '' }}</td>
          <td>
            {{
              relatedChangeTypeMap[props.item.relatedChangeType] ? relatedChangeTypeMap[props.item.relatedChangeType].value : ''
            }}
          </td>
          <td>{{ props.item.step }}</td>
          <td>{{ props.item.assignedTo ? props.item.assignedTo.displayName : '' }}</td>
          <td>{{ props.item.operationalReadinessInspection == 1 ? 'Yes' : 'No' }}</td>
          <td>{{ $filters.DateFilter(props.item.taskReviewDate) }}</td>
          <td>{{ props.item.active ? 'Yes' : 'No' }}</td>
          <td v-if="edit">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-icon @click="showRelationships(props.item.id)" v-on="on">mdi-information-outline</v-icon>
              </template>
              <span>Show Task Relationships</span>
            </v-tooltip>
          </td>
        </tr>
      </template>
    </v-data-table>
    <v-dialog v-model="relationshipDialog" persistent max-width="900">
      <task-relationship
        v-if="relationshipDialog"
        :communityAbbreviation="communityAbbreviation"
        :taskId="taskId"
        :readonly="readonly"
        :close="closeTaskRelationshipDialog"
      >
      </task-relationship>
    </v-dialog>
  </div>
</template>

<script>
import { ChangeTypes, TaskListTypes } from '@/common/types'
import TaskRelationship from '@/components/communityConfig/TaskRelationship'

export default {
  name: 'TaskTable',
  props: {
    tasks: Array,
    edit: Boolean,
    communityAbbreviation: String,
    readonly: Boolean
  },
  components: {
    TaskRelationship
  },
  data() {
    let taskHeaders = [
      {
        title: 'Task',
        key: 'name'
      },
      {
        title: 'Required in order to',
        key: 'taskListType.value'
      },
      {
        title: 'Task Owner',
        key: 'owner.displayName'
      },
      {
        title: 'Related Change Type',
        key: 'relatedChangeType'
      },
      {
        title: 'Step',
        key: 'step'
      },
      {
        title: 'Assigned To',
        key: 'assignedTo.displayName'
      },
      {
        title: 'Operational Readiness Inspection',
        key: 'operationalReadinessInspection'
      },
      {
        title: 'Task Review Date',
        key: 'taskReviewDate'
      },
      {
        title: 'Active',
        key: 'active'
      }
    ]

    if (this.edit) {
      taskHeaders.push({
        title: ''
      })
    }
    return {
      taskHeaders,
      relatedChangeTypeMap: ChangeTypes.properties,
      taskListTypes: Object.values(TaskListTypes.properties).filter(t => t.key !== 'all'),
      taskListType: undefined,
      owner: undefined,
      taskSearch: undefined,
      relationshipDialog: false,
      taskId: ''
    }
  },
  computed: {
    filteredItems() {
      let result = this.tasks

      if (this.taskListType) {
        result = result.filter(t => t.taskListType.key === this.taskListType.key)
      }

      if (this.owner) {
        result = result.filter(t => t.owner && t.owner.id === this.owner.id)
      }

      if (this.taskSearch && this.taskSearch.trim() && this.taskSearch.trim().length >= 3) {
        result = result.filter(t =>
          t.name
            .trim()
            .toLowerCase()
            .includes(this.taskSearch.trim().toLowerCase())
        )
      }

      return result
    },
    owners() {
      // return this.tasks?.filter(t => t.owner).map(t => t.owner)
      const arr = this.tasks?.filter(t => t.owner).map(t => t.owner)
      return Array.from(new Map(arr.map(obj => [obj.id, obj])).values())
    }
  },
  methods: {
    editTask(item) {
      this.$emit('edit', item)
    },
    showRelationships(taskId) {
      this.taskId = taskId
      this.relationshipDialog = true
    },
    closeTaskRelationshipDialog() {
      this.taskId = ''
      this.relationshipDialog = false
    }
  }
}
</script>
